import "./index.css";
import { Input } from "reactstrap";
import { selectInterface } from "utilFunctions/shared/PerformanceSearchBar";
import { useContext, useEffect, useRef, useState } from "react";
import CustomSelect from "Components/CommonComponents/CustomSelect";
import { DateRange } from "react-date-range";
import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css"; // theme css file
import { addDays, format } from "date-fns";
import { setHours, setMinutes, setSeconds, subDays } from "date-fns";
import { ToastContextDispatch } from "Context/CommonContext";
import useWindowSize from "utilFunctions/CustomHooks/useWindowSize";
import FilterSliderComponent from "Components/FilterSliderComponent/FilterSliderComponent";
import useGlobalSearchContext from "Context/GlobalSearchContext";
import { useNavigate } from "react-router-dom";

interface IScheduleFilter {
  room?: any;
  onEndDateInputRef?: any;
  startDate?: any;
  endDate?: any | null;
  syllabusStatus?: any;
  filters?: [];
  subjects: selectInterface[];
  classes?: selectInterface[];
  docTypes?: selectInterface[];
  isNotMarkedVisible?: any;
  isChecked?: boolean;
  setIsChecked?: any;
  setFilterData?: any;
  filterState?: any;
  setFilterState?: any;
  handleFilter?: any;
  min?: string;
  max?: string;
  setMax?: any;
  setMin?: any;
  dateRanges?: any;
  setDateRanges?: any;
  isNotmarkedVisible: boolean;
  open: any;
  setOpen: any;
  setSelectedDateRange: any;
  isPaneOpen?: boolean;
  setisPaneOpen?: any;
  NotMarkedChangeHandler?: any;
}
const ScheduleFilter = ({
  subjects,
  setFilterData,
  filterState,
  setFilterState,
  dateRanges,
  setDateRanges,
  handleFilter,
  isChecked,
  setIsChecked,
  isNotMarkedVisible,
  isNotmarkedVisible,
  open,
  setOpen,
  setSelectedDateRange,
  NotMarkedChangeHandler,
}: IScheduleFilter) => {
  const { globalSearchData, saveGlobalSearchData } = useGlobalSearchContext();
  const ToastDispatch = useContext<any>(ToastContextDispatch);
  const date = new Date();
  const minDate = subDays(date, 365);
  const maxAllowedRangeInMilliseconds = 7 * 24 * 60 * 60 * 1000;
  const refOne = useRef<HTMLDivElement>(null);
  const [dateUpdated, setDateUpdated] = useState<any>(false);
  const [isRangeExceeded, setIsRangeExceeded] = useState<boolean>(false);
  const { screen }: any = useWindowSize();
  const navigate = useNavigate();
  const [filterheadingListing, setfilterheadingListing] = useState([
    {
      name: "Subject",
      nickName: "subject",
      data: subjects,
      singleSelect: true,
      filterSelectedData: [],
    },
  ]);
  useEffect(() => {
    setfilterheadingListing([
      {
        name: "Subject",
        nickName: "subject",
        data: subjects,
        singleSelect: true,
        filterSelectedData: [],
      },
    ]);
  }, [subjects]);
  const handleAddFilterArrayList = (name: string, val: any) => {
    setFilterState((prevState: any) => ({
      ...prevState,
      [name]: val,
    }));
    handleFilter({ ...filterState, [name]: val });
  };

  useEffect(() => {
    // event listeners
    document.addEventListener("keydown", hideOnEscape, true);
    document.addEventListener("click", hideOnClickOutside, true);
  }, []);
  useEffect(() => {
    if (dateUpdated) {
      if (!isRangeExceeded) {
        navigate(location.pathname, { state: null, replace: true });
        handleFilterDate(dateRanges);
        setIsChecked(false);
      }
    }
  }, [dateUpdated]);

  const handleFilterDate = (dateRanges: any) => {
    const newStartdate = format(
      setSeconds(
        setMinutes(
          setHours(subDays(new Date(dateRanges[0].startDate), 1), 18),
          30
        ),
        0
      ),
      "yyyy-MM-dd HH:mm:ss"
    );
    const newEndDate = format(
      setSeconds(
        setMinutes(setHours(new Date(dateRanges[0].endDate), 18), 29),
        0
      ),
      "yyyy-MM-dd HH:mm:ss"
    );
    handleAddFilterArrayList("startDate", newStartdate);
    handleAddFilterArrayList("endDate", newEndDate);
    if (newStartdate && newEndDate && ["md", "xs", "sm"].includes(screen)) {
      dateRangeHandler();
    }
  };
  const dateRangeHandler = () => {
    const dateTimeValueRange =
      isChecked &&
      dateRanges[0].startDate != null &&
      dateRanges[0].endDate != null
        ? `${format(dateRanges[0].startDate, "dd MMM")}`
        : dateRanges[0].startDate != null && dateRanges[0].endDate != null
        ? `${format(dateRanges[0].startDate, "dd MMM")} - ${format(
            dateRanges[0].endDate,
            "dd MMM"
          )}`
        : dateRanges[0].startDate != null && dateRanges[0].endDate == null
        ? `${format(dateRanges[0].startDate, "dd MMM")}`
        : dateRanges[0].startDate == null && dateRanges[0].endDate != null
        ? `dd MMM - ${format(dateRanges[0].endDate, "dd MMM")}`
        : "dd MMM";
    setSelectedDateRange(dateTimeValueRange);
  };
  // hide dropdown on ESC press
  const hideOnEscape = (e: any) => {
    if (e.key === "Escape") {
      setOpen(false);
    }
  };

  // Hide on outside click
  const hideOnClickOutside = (e: any) => {
    if (refOne.current) {
      if (!refOne.current.contains(e.target)) {
        setOpen(false);
      }
    }
  };

  const handleRangeFocusedChange = (dateRange: any) => {
    if (dateRange[0] == 0 && dateRange[1] == 0) {
      setDateUpdated(new Date().getMilliseconds());
    }
  };
  const applyFilterHandler = () => {
    const obj: any = {};
    filterheadingListing.forEach((ele: any) => {
      obj[ele.nickName] = ele.singleSelect
        ? ele.filterSelectedData[0]
        : ele.filterSelectedData;
    });
    setFilterState(obj);
    setFilterData(obj);
  };
  const dateTimeValue =
    isChecked &&
    dateRanges[0].startDate != null &&
    dateRanges[0].endDate != null
      ? `${format(new Date(dateRanges[0].startDate), "dd MMM")}`
      : dateRanges[0].startDate != null && dateRanges[0].endDate != null
      ? `${format(new Date(dateRanges[0].startDate), "dd MMM")} - ${format(
          new Date(dateRanges[0].endDate),
          "dd MMM"
        )}`
      : dateRanges[0].startDate != null && dateRanges[0].endDate == null
      ? `${format(new Date(dateRanges[0].startDate), "dd MMM")}`
      : dateRanges[0].startDate == null && dateRanges[0].endDate != null
      ? `dd MMM - ${format(new Date(dateRanges[0].endDate), "dd MMM")}`
      : "dd MMM";
  const filterCount = { ...filterState };
  delete filterCount["eventType"];
  const filterLength = filterCount
    ? Object.values(filterCount).filter((ele: any) => ele != null).length
    : 0;
  const handleClearAllFilter = () => {
    navigate(location.pathname, { state: null, replace: true });
    setFilterState({
      eventType: filterState.eventType,
      subject: null,
      isClear: true,
    });
    setDateRanges([
      {
        startDate: new Date(
          format(
            setSeconds(setMinutes(setHours(subDays(new Date(), 3), 18), 30), 0),
            "yyyy-MM-dd HH:mm:ss"
          )
        ),
        endDate: new Date(
          format(
            setSeconds(setMinutes(setHours(addDays(new Date(), 3), 18), 30), 0),
            "yyyy-MM-dd HH:mm:ss"
          )
        ),
        key: "selection",
      },
    ]);
  };
  return (
    <>
      {["xs", "sm", "md"].includes(screen) && (
        <FilterSliderComponent
          width={"100%"}
          isPaneOpen={globalSearchData?.isSchedule}
          hideHeader={true}
          filterheadingListing={filterheadingListing}
          setfilterheadingListing={setfilterheadingListing}
          applyFilterHandler={applyFilterHandler}
          setisPaneOpen={() => {
            saveGlobalSearchData({
              ...globalSearchData,
              isSchedule: false,
            });
          }}
          resetHandler={handleClearAllFilter}
        ></FilterSliderComponent>
      )}

      <Input
        onChange={(e) => {
          e.preventDefault();
        }}
        name={"dateRange"}
        id={"reactDateRange"}
        disabled={isNotMarkedVisible}
        value={dateTimeValue}
        className="form-control date-input-css relative inline-flex w-full"
        placeholder={"Date"}
        onClick={() => setOpen((open: any) => !open)}
      />
      <div ref={refOne}>
        {open && (
          <>
            {["xs", "sm", "md"].includes(screen) && (
              <div className="d-flex w-100 justify-content-between">
                <div className="markedTodayDiv d-none">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    checked={isNotmarkedVisible}
                    onChange={NotMarkedChangeHandler}
                  />
                  <span className="filterCheckboxSpan">Not marked</span>
                </div>
              </div>
            )}
            <DateRange
              months={1}
              rangeColors={["#00B0F5"]}
              direction="horizontal"
              className={
                ["xs", "sm", "md"].includes(screen)
                  ? "calendarElementMobileView"
                  : "calendarElement"
              }
              startDatePlaceholder="start date"
              endDatePlaceholder="mm/dd/yyyy"
              editableDateInputs={true}
              minDate={minDate}
              maxDate={addDays(new Date(), 365)}
              onRangeFocusChange={(DateRange) => {
                handleRangeFocusedChange(DateRange);
              }}
              onChange={(item) => {
                const { startDate, endDate } = item.selection;
                if (endDate != undefined && startDate != undefined) {
                  // Calculate the difference between start and end dates in milliseconds
                  const rangeDuration = endDate.getTime() - startDate.getTime();

                  // Check if the selected range is within the allowed limit
                  if (rangeDuration <= maxAllowedRangeInMilliseconds) {
                    const newObj = {
                      startDate: startDate,
                      endDate: endDate,
                      key: "selection",
                    };
                    const nObj = [newObj];
                    setIsRangeExceeded(false);
                    setDateRanges(() => [...nObj]);
                  } else {
                    setIsRangeExceeded(true);
                    ToastDispatch({
                      isOpen: true,
                      type: "Error",
                      message:
                        "Maximum allowed range duration exceeded. (Max range is 7 days)",
                    });
                  }
                }
              }}
              moveRangeOnFirstSelection={false}
              ranges={dateRanges}
            />
          </>
        )}
      </div>
      {["xxl", "xl", "lg"].includes(screen) && (
        <div>
          <CustomSelect
            isSelected={
              filterState?.subject != null
                ? true
                : filterState?.subject != null
                ? true
                : false
            }
            placeholder="Subject"
            width="160px"
            options={subjects}
            isSearchable={false}
            menuPlacement="bottom"
            isClearable={true}
            disabled={isNotMarkedVisible}
            menuShouldScrollIntoView={true}
            closeMenuOnSelect={true}
            onChange={(selected: any) => {
              handleAddFilterArrayList("subject", selected);
            }}
            value={filterState?.subject ? filterState?.subject : null}
          />
        </div>
      )}
      {filterLength != 0 && ["xxl", "xl", "lg"].includes(screen) && (
        <div
          onClick={() => {
            if (filterLength != 0) {
              handleClearAllFilter();
            }
          }}
          className="scheduleFilterReset d-flex justify-content-center align-items-center cursor-pointer white-space: nowrap"
        >
          <span
            className={
              filterLength != 0
                ? "filterSpan white-space: nowrap"
                : "filterspanWidth"
            }
          >
            Reset All{" "}
          </span>
        </div>
      )}
    </>
  );
};
export default ScheduleFilter;
